/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description Home Button
 */
import { Button, ButtonProps } from 'antd';
import { Reload as ReloadIcon } from '@icon-park/react';

/**
 * Reload button
 * @param props
 * @returns {React.FC} Reload
 */
const Reload: React.FC<ButtonProps> = (props) => {
	return (
		<Button type='primary' onClick={() => globalThis.location.reload()} {...props}>
			<ReloadIcon /> {'Reload'}
		</Button>
	);
};

export default Reload;
